import { DesignerMode } from "../../../../types"
import { MUIIcon } from "../../../../../widgets"
import clsx from "clsx"

export const PageViewButtonGroup = ({ groupName, type, onChange }: {
    groupName: string,
    type: DesignerMode,
    onChange: (type: DesignerMode) => void
}) => {
    return <div className='d-flex gap-2 fs-8'>
        <PageViewButton
            iconName='ModeEditOutlineOutlined'
            groupName={groupName}
            type={DesignerMode.Draft}
            value={type}
            onChange={onChange} />
        <PageViewButton
            iconName='VisibilityOutlined'
            groupName={groupName}
            type={DesignerMode.View}
            value={type}
            onChange={onChange} />
    </div>
}

const PageViewButton = ({ groupName, type, value, iconName, onChange }: {
    groupName: string,
    type: DesignerMode,
    value: DesignerMode,
    iconName: string,
    onChange: (type: DesignerMode) => void
}) => {
    const className = clsx("btn btn-xs d-flex align-self-center align-items-center px-2 py-0 fs-8", {
        "btn-primary": value === type,
        "btn-secondary": value !== type,
    })

    const controlId = `${groupName}-${type}`;

    return <>
        <input
            type="radio"
            className="btn-check"
            name={groupName}
            id={controlId}
            autoComplete="off"
            onChange={() => onChange(type)}
            checked={value === type} />
        <label className={className} htmlFor={controlId}>
            <MUIIcon iconName={iconName} className="me-1 fs-6" />
            <span>{type === DesignerMode.Draft ? "Draft" : "View"}</span>
        </label>
    </>
}